// pick out the pipeline options fields
export default ({
  channels,
  customisations,
  reductions,
  filters,
  queryCache,
  chartType,
  meta,
  convertedFields,
  calculatedFields,
}) => {
  return {
    channels,
    customisations,
    reductions,
    filters,
    queryCache,
    chartType,
    meta,
    convertedFields,
    calculatedFields,
  };
};
